import { useCallback, useState, useMemo } from 'react';

const INITIAL_PAGE = 1;
const INITIAL_SEARCH_STATE = {
  currentPage: INITIAL_PAGE,
  searchText: '',
  searchChar: '',
  searchOHT: []
};

const FILTER_TYPES = {
  ORG_UNIT_NAME: 'orgUnitName',
  ORG_NAME: 'orgName',
  ORG_UNIT_NAME_START_WITH: 'orgUnitNameStartWith',
  ORG_NAME_START_WITH: 'orgNameStartWith',
  FEI: 'fei',
  OHT: 'oht'
};

const useSearchState = (options = { includeFeiSearch: true }) => {
  const [searchState, setSearchState] = useState(INITIAL_SEARCH_STATE);

  const updateSearchState = useCallback(updates => {
    setSearchState(prev => ({
      ...prev,
      ...updates,
      currentPage: updates.currentPage ?? INITIAL_PAGE
    }));
  }, []);

  const filters = useMemo(() => {
    const { searchText, searchChar, searchOHT } = searchState;
    const result = [];

    if (searchText) {
      result.push(
        { type: FILTER_TYPES.ORG_UNIT_NAME, value: searchText },
        { type: FILTER_TYPES.ORG_NAME, value: searchText }
      );
    }

    if (searchText && options.includeFeiSearch) {
      result.push({ type: FILTER_TYPES.FEI, value: searchText });
    }

    if (searchChar) {
      result.push(
        { type: FILTER_TYPES.ORG_UNIT_NAME_START_WITH, value: searchChar },
        { type: FILTER_TYPES.ORG_NAME_START_WITH, value: searchChar }
      );
    }

    if (searchOHT?.length) {
      result.push({ type: FILTER_TYPES.OHT, value: searchOHT.join(',') });
    }

    return result;
  }, [searchState, options.includeFeiSearch]);

  return {
    ...searchState,
    setSearchState: updateSearchState,
    filters
  };
};

export default useSearchState;
